/**
 * CAPPONI — refresco en vivo de la escalera del pack.
 *
 * El bloque se pinta en el servidor a partir del carrito, asi que sin esto solo
 * cambia al recargar la pagina. Aqui se vuelve a pedir la seccion con la API de
 * Section Rendering y se sustituye su contenido.
 *
 * Por que se intercepta fetch en vez de escuchar un evento del theme: los
 * eventos de carrito de Horizon vienen del paquete externo @shopify/events y
 * sus nombres literales pueden cambiar entre versiones. Las rutas /cart/add,
 * /cart/change y /cart/update son API publica de Shopify y no cambian. Se
 * escuchan ademas los nombres de evento conocidos, por si acaso.
 */
(function () {
  if (window.__capponiLadderInit) return;
  window.__capponiLadderInit = true;

  var SELECTOR = '[data-capponi-ladder]';
  var timer = null;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  function refresh() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    var section = nodes[0].closest('.shopify-section');
    if (!section || !section.id) return;

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));

    fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('section fetch failed');
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');

        Array.prototype.forEach.call(nodes, function (node) {
          var id = node.getAttribute('data-block-id');
          var fresh =
            doc.querySelector(SELECTOR + '[data-block-id="' + id + '"]') || doc.querySelector(SELECTOR);
          if (!fresh) return;
          node.innerHTML = fresh.innerHTML;
          node.setAttribute('data-stage', fresh.getAttribute('data-stage') || '');
        });
      })
      .catch(function () {
        /* si falla, el bloque se queda como estaba: nunca se vacia */
      });
  }

  [
    'cart:update',
    'cart:lines-update',
    'cart:line-update',
    'cart:change',
    'cart:refresh',
    'cart:error',
  ].forEach(function (name) {
    document.addEventListener(name, schedule);
  });

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var promise = nativeFetch.apply(this, arguments);
    try {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        promise.then(schedule).catch(function () {});
      }
    } catch (error) {
      /* no romper nunca el fetch original */
    }
    return promise;
  };
})();
